export default "/images/framework/EpicBarCht.04489840.svg?04489840";